/*
 * @Author: your name
 * @Date: 2021-12-15 16:45:34
 * @LastEditTime: 2021-12-22 09:14:11
 * @LastEditors: Please set LastEditors
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: \gw-react\src\pages\home\index.js
 */
import React from "react";
import Swiper from "../../components/Swiper";
import { Link } from "react-router-dom";
import { getBanner } from "../../api/index";

export default class Home extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      slideList: [],
      slideList2: [
        {
          name: "【半永久轻氧眉】",
          src: "http://tg.isbelle.com.cn/uploads/images/1-2004131H22b52.jpg",
          price: {
            title: "韩式   雾眉纹眉纹绣",
            num1: "¥680",
            num2: "¥1080",
          },
        },
        {
          name: "【玻尿酸】",
          src: "http://tg.isbelle.com.cn/uploads/images/1-2004131H30M04.jpg",
          price: {
            title: "润百颜海薇玻尿酸填充",
            num1: "¥288",
            num2: "¥880",
          },
        },
        {
          name: "7重好礼紧致抚痕 定格",
          src: "http://tg.isbelle.com.cn/uploads/images/1-21112515163M14.jpg",
          price: {
            title: "深层清洁 水润光泽",
            num1: "¥68",
            num2: "¥198",
          },
        },
      ],
    };
  }

  linkList = [
    {
      src: "/product",
      title: "特色项目",
      imgSrc:
        "http://nb.isbelle.com.cn/templets/2018/wap/images/index/xm_01.jpg",
    },
    {
      src: "/home",
      title: "案例集合",
      imgSrc:
        "http://nb.isbelle.com.cn/templets/2018/wap/images/index/xm_02.jpg",
    },
    {
      src: "/unit",
      title: "技术团队",
      imgSrc:
        "http://nb.isbelle.com.cn/templets/2018/wap/images/index/xm_03.jpg",
    },
    {
      src: "/projectMap",
      title: "品牌介绍",
      imgSrc:
        "http://nb.isbelle.com.cn/templets/2018/wap/images/index/xm_04.jpg",
    },
  ];
  swiperMes = {
    slidesPerView: 3,
    navigation: true,
    className: "rmxm1",
    centeredSlides: true,
    centeredSlidesBounds: true,
    delay: 3000,
  };
  componentDidMount() {
    getBanner({ bannerLoc: 1, bannerType: 1, bannerSource: "mobile" }).then(
      (res) => {
        let list = res.data.map((v) => {
          return {
            src: v.imgUrl,
          };
        });
        this.setState({ slideList: list });
      }
    );
    // getBanner({
    //   bannerLoc: 2,

    //   // bannerSourc: "pc",
    // }).then((res) => {
    //   let list = res.data.map((v) => {
    //     return {
    //       src: v.imgUrl,
    //       bannerType: v.bannerType,
    //     };
    //   });

    //   this.setState({ slideList2: list });
    // });
  }
  swt = () => {
    let myhref = window.location.href;
    let swtlj =
      "http://plt.zoosnet.net/LR/Chatpre.aspx?id=PLT65467523&lng=cn&r=" +
      encodeURIComponent(document.referrer) +
      "&p=" +
      encodeURIComponent(myhref);
    window.open(swtlj, "_blank");
  };
  render() {
    let { slideList, slideList2 } = this.state;
    return (
      <div>
        <div id="contents" className="contents">
          <div className="bannerSlides relative" id="bannerSlides">
            <Swiper slideList={slideList}></Swiper>
          </div>

          <div className="nav clearfix">
            {this.linkList.map((v, index) => (
              <Link key={index} style={{ width: "25%" }} to={v.src}>
                <h1>
                  <img
                    src={v.imgSrc}
                    style={{ width: "100%", height: "auto" }}
                  />
                </h1>
                <p>{v.title}</p>
              </Link>
            ))}
          </div>

          {/* <div className="zdyimg">
            <a onClick={this.swt}>
              <img src="http://nb.isbelle.com.cn/uploads/images/1-1Z2021G301.jpg" />
            </a>
          </div>
          <div className="zdyimg">
            <a>
              <img src="http://nb.isbelle.com.cn/uploads/images/1-1Z2021GA8.jpg" />
            </a>
          </div> */}

          {/* <div className="tmSlides relative" id="tmSlides">
            <Swiper slideList={slideList2} {...this.swiperMes}></Swiper>

            <div
              className="tempWrap"
              style={{
                overflow: "hidden",
                position: "relative",
                background: "#fff",
              }}
            ></div>
            <div className="tmSlide_foncus absolute">
              <span></span>
              <span></span>
            </div>
          </div> */}

          <div className="tmbk" style={{ display: "none" }}>
            <ul>
              <li>
                <a onClick={this.swt}>
                  <img src="http://tg.isbelle.com.cn/uploads/images/1-2004131H22b52.jpg" />
                </a>
              </li>
              <li>
                <a onClick={this.swt}>
                  <img src="http://tg.isbelle.com.cn/uploads/images/1-2004131H30M04.jpg" />
                </a>
              </li>
              <li>
                <a onClick={this.swt}>
                  <img src="http://tg.isbelle.com.cn/uploads/images/1-21112515163M14.jpg" />
                </a>
              </li>
            </ul>
          </div>
          <div className="zdyimg">
            <a href="http://m8.isbelle.com.cn/about/aljh.html">
              <img src="http://nb.isbelle.com.cn/uploads/images/1-1Z2021HZ2.jpg" />
            </a>
          </div>

          <div className="aljhtitle" style={{ display: "none" }}>
            <ul>
              <li className="aljh1" onClick={this.swt}>
                <a>色斑</a>
              </li>
              <li className="aljh2" onClick={this.swt}>
                <a>瘦脸</a>
              </li>
              <li className="aljh3" onClick={this.swt}>
                <a>眼部</a>
              </li>
              <li className="aljh4" onClick={this.swt}>
                <a>鼻部</a>
              </li>
              <li className="aljh5" onClick={this.swt}>
                <a>面部</a>
              </li>
              <li className="aljh6" onClick={this.swt}>
                <a>美肤</a>
              </li>
              <li className="aljh7" onClick={this.swt}>
                <a>抗衰</a>
              </li>
            </ul>
          </div>

          <div
            className="rmal_box"
            style={{ background: "#fff", display: "none" }}
          >
            <div className="rmal_box clearfix aljhc1">
              <div className="rmzl post clearfix">
                <div className="rmzl_text">
                  <div
                    className="rmzl_db clearfix"
                    style={{ height: "60px", marginTop: "15px" }}
                  >
                    <div
                      className="tx"
                      style={{ width: "50px", float: "left" }}
                    >
                      <img
                        src="http://nb.isbelle.com.cn/uploads/190219/1-1Z21Z05SV51.jpg"
                        width="100%,"
                      />
                    </div>
                    <div style={{ width: "150px", float: "left" }}>
                      <div
                        style={{
                          width: "100%",
                          float: "left",
                          height: "25px",
                          lineHeight: "40px",
                          textSlign: "left",
                        }}
                      >
                        小翠
                      </div>
                      <div
                        style={{
                          width: "100%",
                          float: "left",
                          height: "25px",
                          lineHeight: "25px",
                          paddingLeft: "18px",
                          color: "#D7B38F",
                          textAlign: "left",
                          background:
                            "url(http://tg.isbelle.com.cn/templets/2018/wap/images/index/icon.jpg) left center no-repeat",
                          backgroundSize: "auto 50%",
                        }}
                      >
                        超皮秒祛雀斑
                      </div>
                    </div>
                    <div
                      className="dz"
                      style={{
                        textAlign: "left",
                        paddingLeft: "25px",
                        width: "58px",
                        height: "50px",
                        lineHeight: "50px",
                        background:
                          "url(http://tg.isbelle.com.cn/templets/2018/wap/images/index/yicon.jpg) left center no-repeat",
                        backgroundSize: "auto 30%",
                      }}
                    >
                      <a
                        style={{
                          lineHeight: "50px",
                          float: "left",
                        }}
                      >
                        &nbsp,98
                      </a>
                    </div>
                  </div>

                  <div className="rmzl_db clearfix">
                    <a onClick={this.swt}>
                      <div className="db_left">
                        <img
                          src="http://tg.isbelle.com.cn/uploads/images/1-1Z2152059480-L.jpg"
                          style={{ width: "100%", height: "auto" }}
                        />
                      </div>
                    </a>
                  </div>
                  <p style={{ padding: "5px" }}>
                    做完超皮秒之后，我的斑点淡化得非常明显，现在皮肤变得越来越细腻，白净了不少，面部也显得更年轻了。...
                  </p>
                  <h2 className="clearfix">
                    <b>&nbsp,#超皮秒 #祛雀斑</b>
                  </h2>
                </div>
              </div>
              <div className="clear"></div>
            </div>

            <div className="rmal_box clearfix aljhc2">
              <div className="rmzl post clearfix">
                <div className="rmzl_text">
                  <div
                    className="rmzl_db clearfix"
                    style={{ height: "60px", marginTop: "15px" }}
                  >
                    <div
                      className="tx"
                      style={{ width: "50px", float: "left" }}
                    >
                      <img
                        src="http://nb.isbelle.com.cn/uploads/160218/1-16021Q4000b20.jpg"
                        width="100%,"
                      />
                    </div>
                    <div style={{ width: "150px", float: "left" }}>
                      <div
                        style={{
                          width: "100%",
                          float: "left",
                          height: "25px",
                          lineHeight: "40px",
                          textSlign: "left",
                        }}
                      >
                        佩佩
                      </div>
                      <div
                        style={{
                          width: "100%",
                          float: "left",
                          height: "25px",
                          lineHeight: "25px",
                          paddingLeft: "18px",
                          color: "#D7B38F",
                          textAlign: "left",
                          background:
                            "url(http://tg.isbelle.com.cn/templets/2015/wap/images/index/icon.jpg) left center no-repeat",
                          backgroundSize: "auto 50%",
                        }}
                      >
                        瘦脸针
                      </div>
                    </div>
                    <div
                      className="dz"
                      style={{
                        textAlign: "left",
                        paddingLeft: "25px",
                        width: "58px",
                        height: "50px",
                        lineHeight: "50px",
                        background:
                          "url(http://tg.isbelle.com.cn/templets/2015/wap/images/index/yicon.jpg) left center no-repeat",
                        backgroundSize: "auto 30%",
                      }}
                    >
                      <a
                        style={{
                          lineHeight: "50px",
                          float: "left",
                        }}
                      >
                        &nbsp,163
                      </a>
                    </div>
                  </div>

                  <div className="rmzl_db clearfix">
                    <a onClick={this.swt}>
                      <div className="db_left">
                        <img
                          src="http://tg.isbelle.com.cn/uploads/160218/1-16021Q35954P5.jpg"
                          style={{ width: "100%", height: "auto" }}
                        />
                      </div>
                    </a>
                  </div>
                  <p style={{ padding: "5px" }}>
                    术后第 0 天
                    这是我鼻子下巴瘦脸针刚刚打完的效果，感觉好神奇啊，好激动瘦脸针下巴一点也不痛，鼻子进针时有点痛...
                  </p>
                  <h2 className="clearfix">
                    <b>&nbsp,瘦脸针 玻尿酸隆鼻 丰下巴</b>
                  </h2>
                </div>
              </div>
              <div className="clear"></div>
            </div>

            <div className="rmal_box clearfix aljhc3">
              <div className="rmzl post clearfix">
                <div className="rmzl_text">
                  <div
                    className="rmzl_db clearfix"
                    style={{ height: "60px", marginTop: "15px" }}
                  >
                    <div
                      className="tx"
                      style={{ width: "50px", float: "left" }}
                    >
                      <img
                        src="http://nb.isbelle.com.cn/uploads/images/1-1Z22009494cN.jpg"
                        width="100%,"
                      />
                    </div>
                    <div style={{ width: "150px", float: "left" }}>
                      <div
                        style={{
                          width: "100%",
                          float: "left",
                          height: "25px",
                          lineHeight: "40px",
                          textSlign: "left",
                        }}
                      >
                        小锦
                      </div>
                      <div
                        style={{
                          width: "100%",
                          float: "left",
                          height: "25px",
                          lineHeight: "25px",
                          paddingLeft: "18px",
                          color: "#D7B38F",
                          textAlign: "left",
                          background:
                            "url(http://tg.isbelle.com.cn/templets/2015/wap/images/index/icon.jpg) left center no-repeat",
                          backgroundSize: "auto 50%",
                        }}
                      >
                        E-MAX无痕媚眼术
                      </div>
                    </div>
                    <div
                      className="dz"
                      style={{
                        textAlign: "left",
                        paddingLeft: "25px",
                        width: "58px",
                        height: "50px",
                        lineHeight: "50px",
                        background:
                          "url(http://tg.isbelle.com.cn/templets/2015/wap/images/index/yicon.jpg) left center no-repeat",
                        backgroundSize: "auto 30%",
                      }}
                    >
                      <a
                        style={{
                          lineHeight: "50px",
                          float: "left",
                        }}
                      >
                        &nbsp,107
                      </a>
                    </div>
                  </div>

                  <div className="rmzl_db clearfix">
                    <a onClick={this.swt}>
                      <div className="db_left">
                        <img
                          src="http://tg.isbelle.com.cn/uploads/images/1-1Z2152105360-L.jpg"
                          style={{ width: "100%", height: "auto" }}
                        />
                      </div>
                    </a>
                  </div>
                  <p style={{ padding: "5px" }}>
                    我做完双眼皮简直像变了个人，现在非常的自然，朋友都说我眼神中都透露着甜美的感觉，我很喜欢现在这样，确实让我...
                  </p>
                  <h2 className="clearfix">
                    <b>&nbsp,双眼皮、开眼角</b>
                  </h2>
                </div>
              </div>
              <div className="clear"></div>
            </div>

            <div className="rmal_box clearfix aljhc4">
              <div className="rmzl post clearfix">
                <div className="rmzl_text">
                  <div
                    className="rmzl_db clearfix"
                    style={{ height: "60px", marginTop: "15px" }}
                  >
                    <div
                      className="tx"
                      style={{ width: "50px", float: "left" }}
                    >
                      <img
                        src="http://nb.isbelle.com.cn/uploads/images/1-1Z2200950343J.jpg"
                        width="100%,"
                      />
                    </div>
                    <div style={{ width: "150px", float: "left" }}>
                      <div
                        style={{
                          width: "100%",
                          float: "left",
                          height: "25px",
                          lineHeight: "40px",
                          textSlign: "left",
                        }}
                      >
                        亚琼
                      </div>
                      <div
                        style={{
                          width: "100%",
                          float: "left",
                          height: "25px",
                          lineHeight: "25px",
                          paddingLeft: "18px",
                          color: "#D7B38F",
                          textAlign: "left",
                          background:
                            "url(http://tg.isbelle.com.cn/templets/2015/wap/images/index/icon.jpg) left center no-repeat",
                          backgroundSize: "auto 50%",
                        }}
                      >
                        鼻综合手术
                      </div>
                    </div>
                    <div
                      className="dz"
                      style={{
                        textAlign: "left",
                        paddingLeft: "25px",
                        width: "58px",
                        height: "50px",
                        lineHeight: "50px",
                        background:
                          "url(http://tg.isbelle.com.cn/templets/2015/wap/images/index/yicon.jpg) left center no-repeat",
                        backgroundSize: "auto 30%",
                      }}
                    >
                      <a
                        style={{
                          lineHeight: "50px",
                          float: "left",
                        }}
                      >
                        &nbsp,93
                      </a>
                    </div>
                  </div>

                  <div className="rmzl_db clearfix">
                    <a onClick={this.swt}>
                      <div className="db_left">
                        <img
                          src="http://tg.isbelle.com.cn/uploads/images/1-1Z2152106400-L.jpg"
                          style={{ width: "100%", height: "auto" }}
                        />
                      </div>
                    </a>
                  </div>
                  <p style={{ padding: "5px" }}>
                    我之前的鼻头特别圆润，鼻子也挺宽的，现在已经完全自然了，立体的鼻子真的会给面部带来立体式的变化，现实中也不...
                  </p>
                  <h2 className="clearfix">
                    <b>&nbsp,假体隆鼻、注射隆鼻</b>
                  </h2>
                </div>
              </div>
              <div className="clear"></div>
            </div>

            <div className="rmal_box clearfix aljhc5">
              <div className="rmzl post clearfix">
                <div className="rmzl_text">
                  <div
                    className="rmzl_db clearfix"
                    style={{ height: "60px", marginTop: "15px" }}
                  >
                    <div
                      className="tx"
                      style={{ width: "50px", float: "left" }}
                    >
                      <img
                        src="http://nb.isbelle.com.cn/uploads/160218/1-16021Q62P6418.jpg"
                        width="100%,"
                      />
                    </div>
                    <div style={{ width: "150px", float: "left" }}>
                      <div
                        style={{
                          width: "100%",
                          float: "left",
                          height: "25px",
                          lineHeight: "40px",
                          textSlign: "left",
                        }}
                      >
                        媛小宝
                      </div>
                      <div
                        style={{
                          width: "100%",
                          float: "left",
                          height: "25px",
                          lineHeight: "25px",
                          paddingLeft: "18px",
                          color: "#D7B38F",
                          textAlign: "left",
                          background:
                            "url(http://tg.isbelle.com.cn/templets/2015/wap/images/index/icon.jpg) left center no-repeat",
                          backgroundSize: "auto 50%",
                        }}
                      >
                        玻尿酸隆鼻
                      </div>
                    </div>
                    <div
                      className="dz"
                      style={{
                        textAlign: "left",
                        paddingLeft: "25px",
                        width: "58px",
                        height: "50px",
                        lineHeight: "50px",
                        background:
                          "url(http://tg.isbelle.com.cn/templets/2015/wap/images/index/yicon.jpg) left center no-repeat",
                        backgroundSize: "auto 30%",
                      }}
                    >
                      <a
                        style={{
                          lineHeight: "50px",
                          float: "left",
                        }}
                      >
                        &nbsp,101
                      </a>
                    </div>
                  </div>

                  <div className="rmzl_db clearfix">
                    <a onClick={this.swt}>
                      <div className="db_left">
                        <img
                          src="http://tg.isbelle.com.cn/uploads/160218/1-16021Q62JGT.jpg"
                          style={{ width: "100%", height: "auto" }}
                        />
                      </div>
                    </a>
                  </div>
                  <p style={{ padding: "5px" }}>
                    术后第 0 天
                    开始注射的时候有些小紧张，护士给我压力球帮我舒缓紧张。欧院很体贴的询问每一部的感受，瞬间没有紧...
                  </p>
                  <h2 className="clearfix">
                    <b>&nbsp,玻尿酸隆鼻 丰下巴</b>
                  </h2>
                </div>
              </div>
              <div className="clear"></div>
            </div>

            <div className="rmal_box clearfix aljhc6">
              <div className="rmzl post clearfix">
                <div className="rmzl_text">
                  <div
                    className="rmzl_db clearfix"
                    style={{ height: "60px", marginTop: "15px" }}
                  >
                    <div
                      className="tx"
                      style={{ width: "50px", float: "left" }}
                    >
                      <img
                        src="http://nb.isbelle.com.cn/uploads/images/1-1Z22009445E92.jpg"
                        width="100%,"
                      />
                    </div>
                    <div style={{ width: "150px", float: "left" }}>
                      <div
                        style={{
                          width: "100%",
                          float: "left",
                          height: "25px",
                          lineHeight: "40px",
                          textSlign: "left",
                        }}
                      >
                        小恬
                      </div>
                      <div
                        style={{
                          width: "100%",
                          float: "left",
                          height: "25px",
                          lineHeight: "25px",
                          paddingLeft: "18px",
                          color: "#D7B38F",
                          textAlign: "left",
                          background:
                            "url(http://tg.isbelle.com.cn/templets/2015/wap/images/index/icon.jpg) left center no-repeat",
                          backgroundSize: "auto 50%",
                        }}
                      >
                        5s医学美肤
                      </div>
                    </div>
                    <div
                      className="dz"
                      style={{
                        textAlign: "left",
                        paddingLeft: "25px",
                        width: "58px",
                        height: "50px",
                        lineHeight: "50px",
                        background:
                          "url(http://tg.isbelle.com.cn/templets/2015/wap/images/index/yicon.jpg) left center no-repeat",
                        backgroundSize: "auto 30%",
                      }}
                    >
                      <a
                        style={{
                          lineHeight: "50px",
                          float: "left",
                        }}
                      >
                        &nbsp,144
                      </a>
                    </div>
                  </div>

                  <div className="rmzl_db clearfix">
                    <a onClick={this.swt}>
                      <div className="db_left">
                        <img
                          src="http://tg.isbelle.com.cn/uploads/images/1-1Z2152109190-L.jpg"
                          style={{ width: "100%", height: "auto" }}
                        />
                      </div>
                    </a>
                  </div>
                  <p style={{ padding: "5px" }}>
                    之前是有些蜡黄和有些斑点的脸，现在已经很光滑和白嫩了，素颜也能保持很好的状态，不化妆也美美哒。...
                  </p>
                  <h2 className="clearfix">
                    <b>&nbsp,美肤</b>
                  </h2>
                </div>
              </div>
              <div className="clear"></div>
            </div>

            <div className="rmal_box clearfix aljhc7">
              <div className="rmzl post clearfix">
                <div className="rmzl_text">
                  <div
                    className="rmzl_db clearfix"
                    style={{ height: "60px", marginTop: "15px" }}
                  >
                    <div
                      className="tx"
                      style={{ width: "50px", float: "left" }}
                    >
                      <img
                        src="http://nb.isbelle.com.cn/uploads/images/1-1Z220094634143.jpg"
                        width="100%,"
                      />
                    </div>
                    <div style={{ width: "150px", float: "left" }}>
                      <div
                        style={{
                          width: "100%",
                          float: "left",
                          height: "25px",
                          lineHeight: "40px",
                          textSlign: "left",
                        }}
                      >
                        小琴
                      </div>
                      <div
                        style={{
                          width: "100%",
                          float: "left",
                          height: "25px",
                          lineHeight: "25px",
                          paddingLeft: "18px",
                          color: "#D7B38F",
                          textAlign: "left",
                          background:
                            "url(http://tg.isbelle.com.cn/templets/2015/wap/images/index/icon.jpg) left center no-repeat",
                          backgroundSize: "auto 50%",
                        }}
                      >
                        线雕
                      </div>
                    </div>
                    <div
                      className="dz"
                      style={{
                        textAlign: "left",
                        paddingLeft: "25px",
                        width: "58px",
                        height: "50px",
                        lineHeight: "50px",
                        background:
                          "url(http://tg.isbelle.com.cn/templets/2015/wap/images/index/yicon.jpg) left center no-repeat",
                        backgroundSize: "auto 30%",
                      }}
                    >
                      <a
                        style={{
                          lineHeight: "50px",
                          float: "left",
                        }}
                      >
                        &nbsp,190
                      </a>
                    </div>
                  </div>

                  <div className="rmzl_db clearfix">
                    <a onClick={this.swt}>
                      <div className="db_left">
                        <img
                          src="http://tg.isbelle.com.cn/uploads/images/1-1Z2152109570-L.jpg"
                          style={{ width: "100%", height: "auto" }}
                        />
                      </div>
                    </a>
                  </div>
                  <p style={{ padding: "5px" }}>
                    圆圆脸的我现在居然有下巴线条了，脸也窄了不少，轮廓线条变精致好看了，整个人看上去年轻了不少。
                    ...
                  </p>
                  <h2 className="clearfix">
                    <b>&nbsp,面部线雕、面部提拉</b>
                  </h2>
                </div>
              </div>
              <div className="clear"></div>
            </div>
          </div>

          <div className="zdyimg">
            <a>
              <img src="http://nb.isbelle.com.cn/uploads/images/1-20092Z94T0.jpg" />
            </a>
          </div>
          <div className="zdyimg">
            <a>
              <img src={require("../../assets/images/jstd/1.jpg")} />
              {/* <img src={require("../../assets/images/jstd.jpg")} /> */}
            </a>
          </div>
          {/* <div className="zdyimg">
            <a>
              <img src="http://nb.isbelle.com.cn/uploads/images/1-20092Z94T0-51.jpg" />
            </a>
          </div> */}
          <div className="zdyimg">
            <a>
              <img src="http://nb.isbelle.com.cn/uploads/images/1-20092Z94T0-52.jpg" />
            </a>
          </div>
        </div>
      </div>
    );
  }
}
